// Switches for the ArcDisk demo.
//
// Whether the demo is visible is a Mosaico feature flag, read through the
// app's own useFeatureToggle hook (see useArcDiskDemo.ts) from what the
// backend serves in GET /api/arc_mosaico/features/current: for a user with a
// selected school, that school's `features`; for a user without one, the
// global Flipper flags. So the flag is created and enabled in the Flipper UI
// (/flipper/features) and then granted to each demo school in Mosaico's own
// /admin/feature-flags page. No per-user targeting.
export const ARCDISK_DEMO_FLAG = 'arcdisk-demo'

// The one build-time value: the ArcDisk backend origin, used ONLY to fetch the
// raw submission files (images, PDFs) for previews. Read the way the rest of
// the app reads REACT_APP_* vars — from src/env.json, which build.js /
// serve.js write from the environment before bundling (the value is public).
// Builds that set nothing (staging / production pipelines pass no REACT_APP_*
// values) fall back to the ArcDisk demo preview, so previews work out of the
// box. All other demo data is bundled fixtures.
import dataEnv from '../env.json'

const env = dataEnv as Record<string, string | undefined>

const DEFAULT_ARCDISK_API_URL = 'https://arcdisk-prototype-git-mosaico-demo-liftoff.vercel.app'

export const ARCDISK_API_URL: string =
  ((env['process.env.REACT_APP_ARCDISK_API_URL'] ?? '').replace(/^"|"$/g, '') || DEFAULT_ARCDISK_API_URL).replace(
    /\/+$/,
    '',
  )
